import { keyframes } from 'styled-components';

export const getSpinKeyframes = (finalRotationDegree: number) => keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(${finalRotationDegree}deg);
  }
`;
